<template>
  <div id="invoices-page">

    <div class="first-row">
      <div class="heading-large">Exports</div>
      <div class="btn btn-success" @click="show('create')" v-if="view === 'index'">New export</div>
      <div class="btn btn-success" @click="show('index')" v-if="view === 'create'">Export list</div>

    </div>

    <div class="second-row row" v-if="view === 'index'">
      <div class="col">
        <table class="table">
          <tr>
            <th>Date</th>
            <th>Export range</th>
            <th>Exported sheets</th>
            <th>Actions</th>
          </tr>
          <tr v-for="exp in exports">
            <td>{{ exp.date }}</td>
            <td>{{ exp.startDate }} - {{ exp.endDate }}</td>
            <td>
              <div v-if="exp.meta.sheets.user_summary">
                User statistics summary
                <span v-if="exp.status === 'generating'">
                  <span v-if="exp.progress['user_summary']">{{ Math.floor((exp.progress['user_summary']['entries'] * 100) / exp.progress['user_summary']['total']) || 0 }}% </span>
                </span>
              </div>
              <div v-if="exp.meta.sheets.user_detailed">
                User statistics detailed
                <span v-if="exp.status === 'generating'">
                  <span v-if="exp.progress['user_detailed']">{{ Math.floor((exp.progress['user_detailed']['entries'] * 100) / exp.progress['user_detailed']['total']) || 0 }}% </span>
                </span>
              </div>
              <div v-if="exp.meta.sheets.invoicing_summary">
                Invoicing summary
                <span v-if="exp.status === 'generating'">
                  <span v-if="exp.progress['invoicing_summary']">{{ Math.floor((exp.progress['invoicing_summary']['entries'] * 100) / exp.progress['invoicing_summary']['total']) || 0 }}% </span>
                </span>
              </div>
              <div v-if="exp.meta.sheets.invoicing_detailed">
                Invoicing detailed
                <span v-if="exp.status === 'generating'">
                  <span v-if="exp.progress['invoicing_detailed']">{{ Math.floor((exp.progress['project_analysis']['entries'] * 100) / exp.progress['project_analysis']['total']) || 0 }}% </span>
                </span>
              </div>
              <div v-if="exp.meta.sheets.project_analysis">
                Financial project analysis
                <span v-if="exp.status === 'generating'">
                  <span v-if="exp.progress['project_analysis']">{{ Math.floor((exp.progress['project_analysis']['entries'] * 100) / exp.progress['project_analysis']['total']) || 0 }}% </span>
                </span>
              </div>
              <div v-if="exp.meta.sheets.project_progress">
                Project Progress
                <span v-if="exp.status === 'generating'">
                  <span v-if="exp.progress['project_progress']">{{ Math.floor((exp.progress['project_progress']['entries'] * 100) / exp.progress['project_progress']['total']) || 0 }}% </span>
                </span>
              </div>
            </td>
            <td>
              <div disabled="true" class="badge badge-info" v-if="exp.status === 'in_queue'">Queued</div>
              <div disabled="true" class="badge badge-warning" v-if="exp.status === 'generating'">Generating</div>
              <div disabled="true" class="badge badge-danger" v-if="exp.status === 'failed'">Failed</div>
              <a :href="exp.link" target="_blank" class="btn btn-sm btn-success" v-if="exp.status === 'done'">Download</a>
              <div class="btn btn-sm btn-danger" @click="destroy(exp)" v-if="exp.status === 'done' || exp.status === 'failed'">Delete</div>
            </td>
          </tr>
        </table>
      </div>

    </div>
    <div class="second-row row" v-if="view === 'create'">
      <div class="col-auto">
        <div class="mt-2">
          <input type="checkbox" v-model="sheets.user_summary">
          <span @click="toggle('user_summary')" class="ml-3 pointer">User statistics summary</span>
        </div>
        <div class="mt-2">
          <input type="checkbox" v-model="sheets.user_detailed">
          <span @click="toggle('user_detailed')" class="ml-3 pointer">User statistics detailed</span>
        </div>
        <div class="mt-2">
          <input type="checkbox" v-model="sheets.invoicing_summary">
          <span @click="toggle('invoicing_summary')" class="ml-3 pointer">Invoicing summary</span>
        </div>
        <div class="mt-2">
          <input type="checkbox" v-model="sheets.invoicing_detailed">
          <span @click="toggle('invoicing_detailed')" class="ml-3 pointer">Invoicing detailed</span>
        </div>
        <div class="mt-2">
          <input type="checkbox" v-model="sheets.project_analysis">
          <span @click="toggle('project_analysis')" class="ml-3 pointer">Financial project analysis</span>
        </div>
        <div class="mt-2">
          <input type="checkbox" v-model="sheets.project_progress">
          <span @click="toggle('project_progress')" class="ml-3 pointer">Project progress</span>
        </div>
        <div v-if="_showDatePicker" class="mt-3">
          <div>
            Pick a date for exports:
          </div>
          <div>
            <date-range-picker ref="datepicker"
                               opens="right"
                               :startDate="startDate"
                               :endDate="endDate"
                               @update="onDateRangeSelected"
                               class="financialReportPicker"
            ></date-range-picker>
          </div>
        </div>
        <div v-if="_showServicesPicker" class="mt-3">
          <div>
            Pick services for project progress:
          </div>
          <div>
            <div v-for="service in services">
              <input type="checkbox" v-model="pickedServices[service.id]"> {{ service.name }}
            </div>
          </div>
        </div>
        <button @click="exportData()" class="btn mt-3" :class="{'btn-success': _canExport, 'btn-outline-grey': !_canExport}" :disabled="!_canExport">Export data</button>


      </div>

      <div class="col" v-if="_showProjectPicker">
        <div>Pick projects for project analysis</div>
        <div>
          <input type="text" class="input" placeholder="search" v-model="query">
        </div>
        <div>
          <table>
            <tr>
              <td colspan="3">
                <div class="flex w-100 justify-content-end">
                  <div class="btn btn-success" @click="toggleAllClients()" v-if="_addedProjects.length === 0">Select all</div>
                  <div class="btn btn-danger" @click="toggleAllClients()" v-if="_addedProjects.length > 0">Remove all</div>
                </div>
              </td>
            </tr>
            <template v-for="client in _clientsToShow">
              <tr>
                <td @click="toggleClient(client)" class="pointer">
                  <span v-if="!client.shown">+</span>
                  <span v-if="client.shown">-</span>
                </td>
                <td @click="toggleClient(client)">
                  <span class="ml-3 pointer">{{ client.name }}</span>
                </td>
                <td>
                  <div class="btn btn-outline-success" @click="addProject(client.projects)">+</div>
                  <div class="btn btn-outline-danger" @click="removeProject(client.projects)">-</div>
                </td>
              </tr>
              <tr v-if="client.shown">
                <td></td>
                <td>
                  <table>
                    <tr v-for="project in client.projects">
                      <td>{{ project.name }}</td>
                      <td>
                        <div class="btn btn-sm btn-outline-success" @click.stop="addProject(project)" v-if="!project.added">+</div>
                        <div class="btn btn-sm btn-outline-danger" @click.stop="removeProject(project)" v-if="project.added">-</div>
                      </td>
                    </tr>
                  </table>
                </td>
                <td></td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <div class="col" v-if="_addedProjects.length && _showProjectPicker">
        <div>Selected projects</div>
        <div v-for="project in _addedProjects">
          <div>
            <div>{{ project.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import _ from 'lodash'

export default {
  components: {
    DateRangePicker,
  },
  created() {
    this.axios.get('/n/exports').then(response => {
      this.exports = response.data
    })
    setInterval(() => {
      this.axios.get('/n/exports').then(response => {
        this.exports = response.data
      })
    }, 2000)
    this.axios.get('/n/clients').then(response => {
      this.clients = response.data
    })
    this.axios.get('/n/services').then(response => {
      this.services = response.data.data
      _.each(this.services, service => {
        this.pickedServices[service.id] = false

        if (service.id === 1 || service.id === 2 || service.id === 3) {
          this.pickedServices[service.id] = true
        }
      })
    })
  },
  data() {
    return {
      exports: null,
      view: 'index',
      query: null,
      clientsToShow: null,
      sheets: {
        user_summary: false,
        user_detailed: false,
        invoicing_summary: false,
        invoicing_detailed: false,
        project_analysis: false,
        project_progress: false,
      },
      pickedServices: {},
      pickedProjects: [],
      clients: null,
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
      services: null,
    }
  },
  computed: {
    _canExport() {
      if (
        !this.sheets.user_summary &&
        !this.sheets.user_detailed &&
        !this.sheets.invoicing_summary &&
        !this.sheets.invoicing_detailed &&
        !this.sheets.project_analysis &&
        !this.sheets.project_progress
      ) return false

      if (this.sheets.project_analysis && this._addedProjects.length == 0) return false

      return true
    },
    _clientsToShow() {
      let clients = this.clients
      if (this.query) {
        clients = _.filter(this.clients, client => {
          let regex = new RegExp(this.query, 'gi')
          if (client.name.match(regex)) {
            return true
          }

          let projects = _.filter(client.projects, project => {
            if (project.name.match(regex)) {
              return true
            }
          })

          if (projects.length > 0) {
            return true
          }

          return false
        })
      }

      clients = _.filter(clients, client => {
        return client.projects.length > 0
      })

      return clients
    },
    _addedProjects() {
      let p = []
      _.each(this.clients, client => {
        _.each(client.projects, project => {
          if (project.added) {
            p.push(project)
          }
        })
      })

      return p
    },
    _showServicesPicker() {
      if (this.sheets.project_progress) {
        return true
      }

      return false
    },
    _showProjectPicker() {
      if (this.sheets.project_analysis) {
        return true
      }

      return false
    },
    _showDatePicker() {
      if (this.sheets.project_progress || this.sheets.user_summary || this.sheets.user_detailed || this.sheets.invoicing_summary || this.sheets.invoicing_detailed) {
        return true
      }

      return false
    },
    _currentMonth() {
      return moment().add(this.monthCounter, 'month').format('YYYY MMMM')
    }
  },
  methods: {
    destroy(exp) {
      if (!confirm('Are you sure?')) return

      this.axios.delete('/n/exports/' + exp.id).then(response => {
        this.exports = response.data
      })
    },
    exportData() {

      let data = {
        sheets: this.sheets,
        services: this._showServicesPicker ? _.filter(_.map(this.pickedServices, (v, k) => {
          if (v) {
            return k
          }
        })) : [],
        projects: _.map(this._addedProjects, p => p.id),
        startDate: this.startDate,
        endDate: this.endDate,
      }

      this.axios.post('/n/exports', data).then(response => {
        this.show('index')
        this.exports = response.data
      })

    },
    addProject(projects) {
      if (projects.id) {
        projects = [projects]
      }

      _.each(projects, project => {
        this.$set(project, 'added', true)
      })

    },
    removeProject(projects) {
      if (projects.id) {
        projects = [projects]
      }

      _.each(projects, project => {
        this.$set(project, 'added', false)
      })
    },
    toggleClient(client) {
      if (!client.shown) {
        this.$set(client, 'shown', true)
      } else {
        this.$set(client, 'shown', false)
      }
    },
    toggleAllClients() {
      let add = !(this._addedProjects.length > 0)
      _.each(this.clients, client => {
        _.each(client.projects, project => {
          this.$set(project, 'added', add)
        })
      })
    },
    toggle(thing) {
      this.sheets[thing] = !this.sheets[thing]
    },
    show(view) {
      this.view = view
    },
    onDateRangeSelected(event) {
      this.startDate = moment(event.startDate).format('YYYY-MM-DD')
      this.endDate = moment(event.endDate).format('YYYY-MM-DD')
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/exports/index.vue